import { isNumber, memoize, toString, upperFirst } from 'lodash-es'
import { arr_first, blank, data_get, OptionalValue, spf } from '../../shared/utils/common';
import { SEVERITY_LEVEL_COLOR_MAPPING, SEVERITY_LEVEL_MAPPING } from './constants';
import { AssetActualFault } from './types';

export const get_severity_level_label = memoize((level: OptionalValue<number | string>): string => {
  if (blank(level)) {
    return 'Unknown';
  }

  if (isNumber(level)) {
    level = toString(level);
  }

  const labels = data_get(SEVERITY_LEVEL_MAPPING, level);

  if (blank(labels)) {
    return 'Unknown';
  }

  return upperFirst(arr_first(labels));
});

export const get_severity_level_color = (level: OptionalValue<number | string>): OptionalValue<string> => {
  if (blank(level)) {
    return null;
  }

  if (isNumber(level)) {
    level = toString(level);
  }

  const color = data_get(SEVERITY_LEVEL_COLOR_MAPPING, level);

  if (blank(color)) {
    return null;
  }

  return color;
}

export const compute_asset_displayed_text = (asset: {
  serial_number: string;
  name?: string;
}): string => {
  const name = data_get(asset, 'name');
  const serial = data_get(asset, 'serial_number');

  if (blank(name) || name === serial) {
    return spf('#%s', {
      args: [serial],
    });
  }

  return spf('%s (#%s)', {
    args: [name, serial],
  });
}

export const sort_severity_by_criticality = (faults: AssetActualFault[]): AssetActualFault[] => faults.sort((a, b) => {
  const level = b.severity_level - a.severity_level;

  if (level !== 0) {
    return level;
  }

  return new Date(b.date_reported).getTime() - new Date(a.date_reported).getTime();
});